import { useQuery } from "react-query";

import axios, { AxiosError } from "axios";

import { PAD_SCENARIO_SERVICE_ADDRESS } from "../../../constants/app.constants";
import { ScenarioField } from "../types/field";

const API_URL = `${PAD_SCENARIO_SERVICE_ADDRESS}/api/v1/pad-scenario`;

export interface FetchScenarioFieldsResponse {
  fields: ScenarioField[];
}

const fetchScenarioFields = async (
  scenarioId: string
): Promise<FetchScenarioFieldsResponse> => {
  const response = await axios.get<FetchScenarioFieldsResponse>(
    `${API_URL}/${scenarioId}/fields`
  );

  return response.data;
};

export const useFetchScenarioFields = (scenarioId?: string) => {
  return useQuery<FetchScenarioFieldsResponse, AxiosError>(
    ["scenarioFields", scenarioId],
    () => {
      if (!scenarioId) {
        throw new Error("scenarioId is required");
      }
      return fetchScenarioFields(scenarioId);
    },
    {
      enabled: !!scenarioId,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000 // 10 minutes
    }
  );
};
